module.exports = __webpack_public_path__ + "img/boxea.6691ba9c.png";